import React from "react";
import { useHistory } from "react-router-dom";
import { Title, BodyTextLarge } from "@minerva-analytics/pantheon";
import { Helmet } from "react-helmet";

import {
  ContactUsContainer,
  CardContent,
  IconText,
  MailIcon,
  ContactText,
  BuildingIcon,
  SubscribeButton,
  ContactCard as Card,
  Background,
} from "./ContactUs.styles";
import { CONTACT_TEXT, CONTACT_TITLE } from "../../text";
import { LUCINA_DOMAIN } from "../../constants";

const ContactUs = () => {
  const history = useHistory();

  const navToHome = () => {
    history.push(`/`);
  };

  return (
    <>
      <Helmet>
        <title>Contact Us | The Science Spotlight </title>
        <meta
          name="og:title"
          property="og:title"
          content="Contact Us | The Science Spotlight"
        />
        <meta
          name="og:description"
          property="og:description"
          content="Need to get in touch with us? You can find all our contact information right here!"
        />
        <meta
          name="description"
          property="description"
          content="Need to get in touch with us? You can find all our contact information right here!"
        />
      </Helmet>
      <ContactUsContainer>
        <Card>
          <CardContent>
            <Title>{CONTACT_TITLE}</Title>
            <BodyTextLarge>{CONTACT_TEXT}</BodyTextLarge>
            <IconText>
              <MailIcon />
              <ContactText>{`help@${LUCINA_DOMAIN}`}</ContactText>
            </IconText>
            <IconText>
              <BuildingIcon />
              <ContactText>
                1770 Massachusetts Ave #268 <br />
                Cambridge, MA 02140
              </ContactText>
            </IconText>
            <ContactText>Not subscribed yet?</ContactText>
            <SubscribeButton onClick={navToHome}>
              Sign Up Today for Free
            </SubscribeButton>
          </CardContent>
        </Card>
        <Background />
      </ContactUsContainer>
    </>
  );
};

export default ContactUs;
